import { createBrowserHistory } from 'history';
import Tracker from 'core/api/tracking/tracker';

export const history = createBrowserHistory();

history.listen(() => {
  Tracker.trackPageView();
  if (window?.TriplePixel) window.TriplePixel('pageLoad');
});

export default history;
